export default __webpack_public_path__ + "static/media/claim-process-flow-chart.aebd4750.svg";